export default __webpack_public_path__ + "static/Wwise-preview-05633248b445197b3f8b1aca1db96539.jpg";